import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgImport() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      d: "M8.164 17H5.279C4.224 17 2 16 2 13s2.34-4.269 3.63-4.269C5.63 6.977 7.055 3 11.825 3s6.352 3.82 6.547 5.731C19.62 8.81 22 10 22 13s-2.458 4.039-3.627 4h-2.735M12 22V11.836",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), _jsx("path", {
      d: "M8.293 13.293a1 1 0 101.414 1.414l-1.414-1.414zM12 11l.707-.707a1 1 0 00-1.414 0L12 11zm2.293 3.707a1 1 0 001.414-1.414l-1.414 1.414zm-4.586 0l3-3-1.414-1.414-3 3 1.414 1.414zm1.586-3l3 3 1.414-1.414-3-3-1.414 1.414z",
      fill: "currentColor"
    }, void 0)]
  }), void 0);
}

export default SvgImport;